import React from "react";
import { FaStar } from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";
import boy from "../img/Group 9.png";
import both from "../img/both.png";
import Children2Img from "../img/2_2_children.png";
import main from "../img/main.png";
import Review from "../components/Review";
import Package from "../components/Package";
import Protect from "../components/Protect";

const reviews = [
  {
    text: "Every educator should take this course. It gave me practical tools that I can use in my classroom immediately.",
    name: "Rachel Collins",
    work: "High School Teacher",
  },
  {
    text: "This is the best training I’ve seen in 25+ years of education. My staff feels confident and prepared.",
    name: "Lauren Mitchell",
    work: "Daycare Director",
  },
  {
    text: "AngelWatch is the most realistic, engaging, and effective safety training we’ve ever had. Every school should be using this program.",
    name: "James Carter",
    work: "Officer",
  },
];

export default function HowItWork() {
  return (
    <>
      <Header />
      <div className="font-sans">
        <div className="relative text-white">
          {/* Hero Image */}
          <div className="lg:h-[354px] w-full h-[150px] overflow-hidden">
            <img
              src={main}
              alt="How it works"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Overlay */}
          <div className="absolute inset-0 flex items-center justify-start">
            <div className="max-w-7xl w-full mx-auto px-4">
              <div className="flex flex-col">
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
                >
                  How It Works
                </h1>
                <div style={{ fontFamily: "Poppins" }} className="text-white">
                  Home &gt; <span className="text-white">How It Works</span>
                </div>
              </div>
            </div>
          </div>
        </div>
  
          <div>
            {/* Top Section */}

            {/* Info Section */}
            <div className="max-w-7xl p-2 mx-auto px-4 py-10 grid md:grid-cols-2 gap-6 items-center">
              <div>
                <h2
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[34px] text-[24px] font-semibold mb-4"
                >
                  How It Works
                </h2>
                <p
                  style={{ fontFamily: "poppins" }}
                  className="text-gray-700 text-[18px] mb-4"
                >
                  AngelWatch is a safety management tool created by educators to
                  support educators. It’s designed to ensure safety compliance,
                  support professional development, and protect your school or
                  organization from liability. Our process is simple, effective,
                  and can be completed entirely online.
                </p>
                <p
                  style={{ fontFamily: "poppins" }}
                  className="text-[18px] text-gray-700"
                >
                  Whether you're managing a preschool, daycare, or enrichment
                  program, our platform helps you remain compliant with
                  essential safety standards, while empowering your staff with
                  the knowledge they need to keep children safe.
                </p>
              </div>
              <div className="flex justify-center">
                <img
                  src={boy}
                  alt="Child Playing"
                  className="max-w-full h-auto"
                />
              </div>
            </div>

            <div className="  ">
              {/* Section 1: What You Get */}
              <div className="bg-[#FCF7EE] mb-10 p-10">
              <div className="max-w-7xl mx-auto space-y-6">
                <h2
                  className="text-xl md:text-2xl font-semibold text-black"
                  style={{ fontFamily: "Fredoka" }}
                >
                  What You Get With This Course Packet
                </h2>
                <p
                  className="text-base md:text-lg text-black"
                  style={{ fontFamily: "Poppins" }}
                >
                  When you enroll in the AngelWatch Emergency Management Course,
                  you’re not just checking a box. You’re arming your business,
                  protecting your staff, and meeting state mandates with a
                  system that’s built to save lives. You’ll pass inspections.
                </p>

                <h3
                  className="text-lg md:text-xl font-medium text-black"
                  style={{ fontFamily: "Fredoka" }}
                >
                  You Receive Access To:
                </h3>
                <ul
                  className="list-disc pl-6 text-base md:text-lg space-y-1"
                  style={{ fontFamily: "Poppins", color: "#000" }}
                >
                  <li>7 Certification Emergency Training Modules</li>
                  <li>Lockdown Module – Internal Lockdown Procedures</li>
                  <li>Active Shooter – Internal Threat</li>
                  <li>Active Shooter - External Threat</li>
                  <li>Shelter and Place Protocols and Procedures</li>
                  <li>Emergency Evacuation Procedures</li>
                  <li>Combative Parent -  Internal Threat</li>
                  <li>Combative Parent - External Threat</li>
                  <li>
                    Fire + Natural Disaster Emergency Response [Included In
                    System-Wide Training]
                  </li>
                </ul>
                <p
                  className="text-base md:text-lg text-black mt-4"
                  style={{ fontFamily: "Poppins" }}
                >
                  These are not just passive video lectures. Each course is
                  interactive, scenario-focused, and designed to prepare your
                  staff to act under real-world conditions. Testing is
                  mandatory. Completion is tracked.
                </p>
              </div>
              </div>
              {/* Section 2: Included With Enrollment */}
              <div className="max-w-7xl p-4 mx-auto space-y-6">
                <h2
                  className="text-xl md:text-2xl font-semibold text-black"
                  style={{ fontFamily: "Fredoka" }}
                >
                  Included With Enrollment
                </h2>
                <p
                  className="text-base md:text-lg text-black"
                  style={{ fontFamily: "Poppins" }}
                >
                  Every course packet includes the AngelWatch Emergency
                  Management Procedures & Practices Handbook — a printable PDF
                  that offers step-by-step, site-referenced Emergency Protocol
                  tools. Great source for guidance as well as backup in your
                  inspection materials.
                </p>

                <h3
                  className="text-lg md:text-xl font-medium text-black"
                  style={{ fontFamily: "Fredoka" }}
                >
                  You’ll receive:
                </h3>
                <ul
                  className="list-disc pl-6 text-base md:text-lg space-y-1"
                  style={{ fontFamily: "Poppins", color: "#000" }}
                >
                  <li>
                    <strong>State-Compliant Emergency SOPs</strong> – Plug and play procedures
                    that meet or exceed state mandates.
                  </li>
                  <li>
                    <strong>Site maps & Audit Checklists</strong> – Everything you need for
                    licensing prep and inspection.
                  </li>
                  <li>
                    <strong>Response Protocols Detailed</strong> – Custom check-ins,
                    reunification, lockdown, and evacuation plans.
                  </li>
                  <li>
                    <strong>Downloadable Templates</strong> – Custom forms, drills, assemblies,
                    classroom posters, and staff documents.
                  </li>
                  <li>
                    <strong>Code System Procedures</strong> – State-compliant procedures for
                    communication under duress.
                  </li>
                  <li>
                    <strong>Printable Staff Certificates</strong> – One for every course passed.
                  </li>
                </ul>
              </div>

              {/* Section 3: Two-column Bottom */}
              <div className="bg-[#FCF7EE] mb-10 p-4 py-10 mt-10">
              <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-12">
                {/* Left */}
                <div className="w-full md:w-1/2 space-y-4">
                  <h2
                    className="text-xl md:text-2xl font-semibold text-black"
                    style={{ fontFamily: "Fredoka" }}
                  >
                    The AngelWatch Emergency Management System
                  </h2>
                  <p
                    className="text-base md:text-lg"
                    style={{ fontFamily: "Poppins", color: "#000" }}
                  >
                    This system is how you get:
                  </p>
                  <ul
                    className="list-disc pl-6 text-base md:text-lg space-y-1"
                    style={{ fontFamily: "Poppins", color: "#000" }}
                  >
                    <li>Rapid Certification in each Emergency Module</li>
                    <li>State Compliant Training</li>
                    <li>Multi-Threat Modules</li>
                    <li>Automated Certificate Tracking</li>
                    <li>Built-in Staff Accountability</li>
                  </ul>
                </div>

                {/* Right (same as previously created section) */}
               
                <div className="w-full max-w-7xl md:w-1/2 space-y-4">
                  <h2
                    className="text-xl md:text-2xl font-semibold text-black"
                    style={{ fontFamily: "Fredoka" }}
                  >
                    The Only National Accreditation That Protects AND Prepares
                  </h2>
                  <ul
                    className="list-disc pl-6 text-base md:text-lg space-y-1"
                    style={{ fontFamily: "Poppins", color: "#000" }}
                  >
                    <li>The American Red Cross</li>
                    <li>The American Heart Association</li>
                    <li>The Department of Homeland Security</li>
                  </ul>
                  <p
                    className="text-base md:text-lg"
                    style={{ fontFamily: "Poppins", color: "#000" }}
                  >
                    Founded by a former U.S. Department of Defense contractor,
                    this system uses protocols built for post-9/11 government
                    facilities— adapted specifically for schools and daycares.
                    This isn’t repurposed corporate safety training. This is
                    life-saving preparation.
                  </p>
                </div>
                </div>
              </div>
            </div>

            {/* Protect Your Children Section */}
            <Protect img={Children2Img} />
            {/* Pricing Section */}
            <div
              style={{ fontFamily: "Fredoka" }}
              className="lg:text-[40px] text-24 p-2 text-center font-semibold  pb-14"
            >
              Prepare to Protect Lives — Get Certified Today  
            </div>
            <div className="max-w-7xl mx-auto lg:mt-20">
              <Package />
            </div>

            {/* Testimonials & Email */}

            {/* Footer Bar */}
          </div>
        </div>
     
      <Review reviews={reviews} />
      <Footer />
    </>
  );
}
